import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navmain from '../main/header';
import Footer from '../main/footer';

const PrivacyPolicy = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
    <Navmain />
    <main className="main flex-grow-1 d-flex align-items-center justify-content-center">
      <section className="bg-home9 w-100">
        <div className="container d-flex justify-content-center align-items-center">
        <div className="row mb-4 w-100">

        <div className="col-lg-12">
    <div className="container mt-5 main-heading-style">
    <h1 className="fw-bold text-center">Privacy Policy, Disclaimer, And Terms & Conditions</h1>
    <p className="text-center text-muted">Effective Date: 01 Dec 2024</p>
    </div>
  </div>

  <div className="col-12">
    <div className="container mt-5">


      <section className="mt-4">
        <h3>1. Introduction</h3>
        <p>
          <strong>Alahdeen B2B</strong> is an e-commerce platform designed to facilitate online business transactions while ensuring the privacy and confidentiality of user data. This Privacy Policy applies to all products and services offered by Alahdeen B2B and explains how we collect, use, and disclose user information. By accessing our platform, you agree to this policy.
        </p>
      </section>

      <section className="mt-4">
        <h3>2. Information We Collect</h3>
        <ul>
          <li><strong>Personal Data:</strong> We collect personal details such as name, email, contact number, and business information during user registration.</li>
          <li><strong>Transaction Details:</strong> Details of the users with transaction information, including product specifications, pricing, shipment details, and dispute records, which are stored when conducting business on the platform.</li>
          <li><strong>Event-Related Information:</strong> Information such as name, address, phone number, and email may be gathered from industry events and trade shows.</li>
          <li><strong>Browsing Data:</strong> Browsing activities, including IP addresses, browsing patterns, and user behavior, are tracked to improve user experience.</li>
        </ul>
        <p>Collected data is divided into Personal Data and Business Data, and users must provide necessary information to complete registration and access platform services.</p>
      </section>

      <section className="mt-4">
        <h3>3. How We Use Your Information</h3>
        <ul>
          <li>Verifying user identity and validating eligibility for site registration.</li>
          <li>Managing user accounts and facilitating transactions.</li>
          <li>Providing customer support and handling inquiries or disputes.</li>
          <li>Enabling interactions between buyers and sellers.</li>
          <li>Managing and publishing social media posts on behalf of customers.</li>
          <li>Sending marketing materials, subject to user consent, related to platform offerings.</li>
          <li>Publishing voluntary user-provided data such as product catalogs and company profiles.</li>
        </ul>
      </section>

      <section className="mt-4">
        <h3>4. Data Protection & Security</h3>
        <p>
          We use encryption and secure servers to keep user data safe. We do not share personal information without permission unless required by Pakistani law or to protect Alahdeen B2B, its users, customers, partners, or others from harm or illegal activities.
        </p>
        <p>
          We may share collected information if required by a court order, legal request, or government regulation. If a user violates the Terms of Use or any agreement with Alahdeen B2B, we may disclose their information to take necessary action or prevent further harm to our platform and users.
        </p>
      </section>

      <section className="mt-4">
        <h3>5. User Rights</h3>
        <ul>
          <li>Access and modify personal information at any time.</li>
          <li>Request the deletion of their account by submitting a request to <a href="mailto:privacy@alahdeen.com">privacy@alahdeen.com</a>.</li>
          <li>Opt-out of marketing communications.</li>
          <li>Adjust browser settings to manage cookies and tracking preferences.</li>
        </ul>
      </section>

      <section className="mt-4">
        <h3>6. Data Retention & Security Measures</h3>
        <p>
          User data on Alahdeen B2B is retained as needed for services or legal compliance. Users cannot delete data independently but may request deletion via <a href="mailto:info@alahdeen.com">info@alahdeen.com</a>. Requests are reviewed and processed, though we cannot guarantee a specific timeframe or data recovery.
        </p>
        <p>
          We protect user information with encryption, firewalls, and secure servers. Users should safeguard login credentials and sign out from shared devices. Despite our security measures, internet data transmission carries inherent risks.
        </p>
      </section>

      <section className="mt-4">
        <h3>7. Cookies Policy</h3>
        <p>
          Our platform uses cookies to enhance user experience and analyze traffic. Cookies are small data files stored on your device that help recognize repeat visits and track browsing patterns. If you do not disable or delete cookies, our servers will recognize your visits and usage behavior.
        </p>
        <p>
          Some business partners, such as advertisers and tracking utilities, may also use cookies. We do not control these third-party cookies.
        </p>
        <p>
          Cookies help us identify users, remember login details, gather usage statistics, target ads based on interests, assist partners in tracking visits, and monitor participation in promotions.
        </p>
        <p>
          Users can manage cookie preferences through browser settings. You may accept, reject, or be notified about cookies. However, disabling cookies may require repeated logins and limit certain site features.
        </p>
      </section>

      <section className="mt-4">
        <h3>8. Minors Policy</h3>
        <p>
          Alahdeen B2B is for people aged 18 and above. Minors (under 18) cannot sign up or use our platform. We do not collect their personal information. If we find that a minor has shared any data, we will delete it immediately.
        </p>
        <p>
          If you are a parent or guardian and think your child has shared personal information, please email us at <a href="mailto:info@alahdeen.com">info@alahdeen.com</a> to remove it.
        </p>
      </section>

      <section className="mt-4">
        <h3>2. Disclaimer</h3>
        <p>
          By using Alahdeen B2B, you acknowledge that all transactions are conducted at your own risk, and you are responsible for making informed decisions. Alahdeen B2B acts solely as a platform to connect businesses and does not guarantee transaction outcomes or mediate disputes.
        </p>
        <p>
          We are not liable for fraud, misrepresentation, or any breaches by buyers, sellers, or manufacturers. We make no warranties regarding the accuracy, quality, or legality of listed products or services. All content is provided "as is" without guarantees.
        </p>
      </section>

      <section className="mt-4">
        <h3>3. Terms & Conditions</h3>
        <h4>User Accounts</h4>
        <p>
          Users must register with accurate and up-to-date business details. Providing false information may lead to account suspension or removal. Alahdeen B2B reserves the right to review, verify, and approve all accounts before granting full access.
        </p>
        <h4>Prohibited Activities</h4>
        <p>
          Users must provide accurate product listings. Posting fraudulent, misleading, or illegal listings is prohibited and may result in account suspension or legal action. Spamming, misusing customer data, or violating Pakistani trade laws is strictly forbidden.
        </p>
        <h4>Dispute Resolution</h4>
        <p>
          Buyers and sellers are responsible for resolving any disputes that arise between them. While Alahdeen B2B may offer assistance in certain cases, we do not guarantee a resolution and encourage users to communicate directly to settle any issues.
        </p>
        <h4>Account Suspension</h4>
        <p>
          Alahdeen may suspend or terminate any account involved in fraud, misuse, or rule violations, including deceptive transactions, false information, spamming, or data misuse.
        </p>
      </section>

      <section className="mt-4">
        <h3>Changes To Privacy Policy</h3>
        <p>
          Any updates to this Privacy Policy will be posted on the platform. Any changes will typically be communicated by uploading a restated and amended Privacy Policy on the Sites. Once published, the latest Privacy Policy will take immediate effect.
        </p>
      </section>

      <section className="mt-4">
        <h3>4. Contact Information</h3>
        <p>If you have suggestions about this Privacy Policy or data requests, please contact:</p>
        <p>
          📧 <a href="mailto:info@alahdeen.com">info@alahdeen.com</a>
        </p>
      </section>

    </div>
  </div>
</div>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
